import React from 'react';
import {findDOMNode} from 'react-dom';
import VDrag from './v-drag';

export const BUS_VSCROLL_DRAGGING_IN_PROGRESS = 'v-scroll:scrollDraggingInProgress'

const debug = false
// const debug = "VScroll"

type Props = {

    className?              : string
    style?                  : style

    containerClass?         : string
    containerStyle?         : style

    scrollTop?              : number
    scrollVisibility?       : 'show' | 'hover' | 'auto'
    minDragHeight           : number

    mutationObserverEnabled?: boolean       // wtf

    onStartReach?           : callback
    onStartPreReach?        : callback
    onEndPreReach?          : callback
    onScroll?               : callback

    children                : any
}

type State = {
    noScroll    : boolean
}

export default class VScroll extends React.Component<Props, State> {

    public bindedHandleMouseMove    : any
    public bindedHandleMouseUp      : any

    public isDragging               : boolean   = false

    public node                     : any
    public childrenContainer        : any
    public vDragNode                : any
    public vTrackNode               : any

    public initialScrollTopDone     : boolean   = false

    public vTrack                   : any // Reference
    public vDrag                    : any // Reference

    public stop                     : any   // func

    public scrollSequence           : any // ???

    public lastClientPosition       : any
    public lastScrollTop            : any

    public childrenMutationObserver : any

    private scrollTop               : number = 0    // Current scroll position

    static defaultProps = {
        scrollVisibility            : 'hover',
        minDragHeight               : 10, //px
        mutationObserverEnabled     : false
    };

    constructor(props:Props) {
        super(props);

        this.state = {
            noScroll: true
        }

        debug && console.log(debug, 'constructor', props)
    }

    addClass(className:string, ref?:any) {
        const node:any = findDOMNode(ref ? ref : this);

        if (node) {
            node.classList.add(className);
        }
    }

    removeClass(className:string, ref?:any) {
        const node : any = findDOMNode(ref ? ref : this);
        if (node) {
            node.classList.remove(className);
        }
    }

    toggleClass(className:string, value:boolean, ref:any) {
        value ? this.addClass(className, ref) : this.removeClass(className, ref)
    }

    componentDidMount() {
        this.bindedHandleMouseMove  = this.handleMouseMove;
        this.bindedHandleMouseUp    = this.handleMouseUp;

        document.addEventListener("mousemove", this.bindedHandleMouseMove, {capture: true});
        document.addEventListener("mouseup", this.bindedHandleMouseUp, {capture: true});

        gd.bus.subscribe(BUS_VSCROLL_DRAGGING_IN_PROGRESS,this,this.onScrollDraggingInProgress);

        this.initialScrollTopDone = false;
        this.node = findDOMNode(this);
        this.childrenContainer = findDOMNode(this.childrenContainer);
        this.vDragNode = findDOMNode(this.vDrag);
        this.vTrackNode = findDOMNode(this.vTrack);
        // this.calculateScroll();

        if (this.props.mutationObserverEnabled) {
            this.childrenMutationObserver = new MutationObserver(mutations => { this.calculateScroll(); });
            this.childrenMutationObserver.observe(this.childrenContainer, { childList: true, subtree: true });
        }

        this.node.addEventListener('scroll', this.onPreventMainNodeHorizontalScroll, true)

        // timeout required to fix initial scroll track size
        setTimeout(()=>{
            this.calculateScroll()
        }, 0)
    }

    componentDidUpdate() {
        this.calculateScroll();
    }

    componentWillUnmount() {
        document.removeEventListener("mousemove", this.bindedHandleMouseMove, {capture: true});
        document.removeEventListener("mouseup", this.bindedHandleMouseUp, {capture: true});
        this.node.removeEventListener('scroll', this.onPreventMainNodeHorizontalScroll, true)

        gd.bus.unsubscribe(this);

        if (this.childrenMutationObserver) this.childrenMutationObserver.disconnect();
    }

    onPreventMainNodeHorizontalScroll = (e:any) => {
        const node : any = findDOMNode(this)
        node.scrollLeft = 0; // Safari horizontal scroll fix
    }

    onScrollDraggingInProgress = (value:boolean) => {
        if (value) {
            this.addClass("v-scroll-is-dragging");
        } else {
            this.removeClass("v-scroll-is-dragging");
        }
    }

    setScrollTop = (value:any, isCentered:boolean, duration:number = 500) => {
        debug && console.log(debug, 'setScrollTop', value, isCentered, duration)

        const scrollTop = isCentered ? value - this.childrenContainer.offsetHeight/2 : value;
        if (this.scrollSequence) this.scrollSequence.stop();
        this.scrollSequence = this.smoothScrollTopTo(this.childrenContainer, scrollTop, duration);
    }

    scrollToBottom = (duration = 500) => {
        debug && console.log(debug, 'scrollToBottom', duration)

        this.setScrollTop(this.childrenContainer.scrollHeight - this.childrenContainer.offsetHeight, false, duration);
    }

    isScrolledToBottom(thresholdValue = 100) {
        const { offsetHeight, scrollHeight, scrollTop } = this.childrenContainer;
        const percentScrolled = (scrollTop / (scrollHeight - offsetHeight)) * 100;
        return percentScrolled >= thresholdValue;
    }

    // Should not do this because calculateScroll can be finished when this component is unmounted
    // and this will cause "React DOM tree root should always have a node reference." error to show.
    // Probably there is some workaround to prevent this (isMounted check is currently deprecated in React).
    /*onClick() {
        this.calculateScroll();
    },*/

    onChildScroll = () => {
        this.calculateScroll();
        if (this.props.onScroll) this.props.onScroll(this.scrollTop);
    }

    calculateScroll = (initScrollTop?:any, forceScroll?:any) => {
        // probably childrenContainer can be undefined if popover with scroll is closed but
        // calculateScroll is called (presumably by smoothScrollTopTo)
        // this issue is caught by sentry (https://sentry.io/organizations/goodday/issues/2560198560)
        // and hadn't been reproduced while testing
        if (!this.childrenContainer) return;

        if ((!this.initialScrollTopDone || forceScroll) && initScrollTop){
            this.initialScrollTopDone = true;
            this.childrenContainer.scrollTop = initScrollTop;
        }

        const { offsetHeight, scrollHeight, scrollTop } = this.childrenContainer;
        let percentVisible = (offsetHeight / scrollHeight) * 100;
        const percentScrolled = (scrollTop / (scrollHeight - offsetHeight)) * 100;

        this.scrollTop      = scrollTop

        if (percentScrolled <= 0){
            if (this.props.onStartReach) this.props.onStartReach();
        }

        if (percentScrolled <= 2) {
            if (this.props.onStartPreReach) this.props.onStartPreReach()
        }

        if (percentScrolled >= 98) {
            if (this.props.onEndPreReach) this.props.onEndPreReach()
        }

        const dragHeight = percentVisible/100 * offsetHeight;
        let dragTopPosition = Math.floor(offsetHeight * scrollTop / scrollHeight);

        const minHeightMode = dragHeight < this.props.minDragHeight;
        if (this.vDrag) this.vDrag.setMinHeightMode(minHeightMode);
        if (minHeightMode) {
            percentVisible = (this.props.minDragHeight / offsetHeight) * 100;
            dragTopPosition = Math.floor((offsetHeight - this.props.minDragHeight + dragHeight) * scrollTop / scrollHeight);
        }

        if (dragTopPosition >= 0) {
            //this.vDragNode.style["top"] = dragTopPosition + 'px';
            //this.vDragNode.style["transform"] = 'translate3d(0px, '+dragTopPosition+'px, 0px)';
            // translate3d is faster, but may render font blurry in chrome
            this.vDragNode.style["transform"] = 'translateY('+dragTopPosition+'px)';
            this.vDragNode.style["height"] = percentVisible+'%';
        }

        const noScroll = percentVisible === 100;
        if(this.state.noScroll !== noScroll){
            this.setState({
                noScroll: noScroll
            })
        }
    }

    protected smoothScrollTopTo = (element:any, target:any, duration:number) => {
        let timer   : any;

        target = Math.round(target);
        duration = Math.round(duration);
        if (duration < 0) {
            return console.log("smoothScrollTopTo: bad duration");
        }
        if (duration === 0) {
            element.scrollTop = target;
            return;
        }

        const start_time = Date.now();
        const end_time = start_time + duration;

        const start_top = element.scrollTop;
        const distance = target - start_top;

        // based on http://en.wikipedia.org/wiki/Smoothstep
        const smooth_step = (start:any, end:any, point:any)=>{
            if(point <= start) { return 0; }
            if(point >= end) { return 1; }
            const x = (point - start) / (end - start); // interpolation
            return x*x*(3 - 2*x);
            //return x;
        };

        // This is to keep track of where the element's scrollTop is
        // supposed to be, based on what we're doing
        let previous_top = element.scrollTop;

        // This is like a think function from a game loop
        const scroll_frame = ()=>{

            /*//check if interrupted
             if(element.scrollTop != previous_top)  return;*/

            // set the scrollTop for this frame
            const now = Date.now();
            const point = smooth_step(start_time, end_time, now);
            const frameTop = Math.round(start_top + (distance * point));
            element.scrollTop = frameTop;

            this.calculateScroll(frameTop, true);

            // check if we're done!
            if(now >= end_time) {
                return;
            }

            // If we were supposed to scroll but didn't, then we
            // probably hit the limit, so consider it done; not
            // interrupted.
            if(element.scrollTop === previous_top
                && element.scrollTop !== frameTop) {
                return;
            }
            previous_top = element.scrollTop;

            // schedule next frame for execution
            timer = setTimeout(scroll_frame, 0);
        };

        this.stop = ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        };

        // boostrap the animation process
        timer = setTimeout(scroll_frame, 0);

        return this;
    }

    handleMouseMove = (e:any) => {
        const { minDragHeight } = this.props;

        if(this.isDragging){
            e.preventDefault();
            const deltaY = this.lastClientPosition - e.clientY;

            const dragHeight = this.childrenContainer.offsetHeight / this.childrenContainer.scrollHeight * this.childrenContainer.offsetHeight;
            let newTop;

            if (dragHeight < minDragHeight) {
                newTop = this.lastScrollTop - (deltaY * this.childrenContainer.scrollHeight / (this.childrenContainer.offsetHeight - minDragHeight + dragHeight));
            } else {
                newTop = this.lastScrollTop - (deltaY * this.childrenContainer.scrollHeight / this.childrenContainer.offsetHeight );
            }

            this.childrenContainer.scrollTop = newTop > 0 ? newTop : 0;

            this.calculateScroll();
        }
    }

    handleMouseDown = (e:any) => {
        //e.stopPropagation();
        const childrenContainer : any = findDOMNode(this.childrenContainer);

        this.isDragging = true;
        this.addClass('is-dragging', this.vTrackNode);
        this.lastClientPosition = e.clientY;
        this.lastScrollTop = childrenContainer?.scrollTop;

        gd.bus.triggerEventDebounced(BUS_VSCROLL_DRAGGING_IN_PROGRESS, true);
    }

    handleMouseUp = (e:React.SyntheticEvent) => {
        //e.stopPropagation();

        this.isDragging = false;
        this.removeClass('is-dragging', this.vTrackNode);

        gd.bus.triggerEventDebounced(BUS_VSCROLL_DRAGGING_IN_PROGRESS, false);
    }

    render() {
        // const scrollWidth = this._getScrollWidth()

        const scrollClasses = Classes('v-scroll', this.props.className, {
            "v-no-scroll"               : this.state.noScroll,
            "v-scroll-show"             : this.props.scrollVisibility === 'show',
            "v-scroll-on-hover"         : this.props.scrollVisibility === 'hover',
            "v-scroll-auto"             : this.props.scrollVisibility === 'auto',
            "v-scroll-no-webkit-scroll" : true //scrollWidth === 0
        })
        const childrenContainerClasses = Classes('v-children-container', this.props.containerClass)

        const childrenContainerStyles = _.assign({
            // width: "calc(100% + "+scrollWidth+"px)"
        }, this.props.containerStyle)

        debug && console.log(debug, 'render', this.props, this.state)

        return (
            <div className={scrollClasses} style={this.props.style}>

                <div ref        = {r=>this.vTrack = r}
                     className  = "v-track">
                    <VDrag ref          = {r=>this.vDrag = r}
                           onMouseDown  = {this.handleMouseDown}/>
                </div>

                <div ref        = {r=>this.childrenContainer = r}
                     className  = {childrenContainerClasses}
                     onScroll   = {this.onChildScroll}
                     style      = {childrenContainerStyles}>
                    {this.props.children}
                </div>

            </div>
        )
    }
}
